// extracted by mini-css-extract-plugin
module.exports = {"main":"Final2_main__TWfit","container":"Final2_container__1sRIs","boxes":"Final2_boxes__2WwJD","box":"Final2_box__13pZx"};